import { Button, Container } from '@mui/material';
import { NavLink } from "react-router-dom";
import { useState } from 'react';
import moment from 'moment';

import { IVendorDetails } from "../../../types/vendor";

import { useUserContext } from "../../../contexts/userContext";
import { useListContext } from '../../../contexts/listContext';

import { VendorService } from "../../../services/vendorService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import VendorDetailsForm from '../../forms/vendorDetailsForm';
import { Icons } from '../../icons';


const VendorAdd = () => {
	const userContext = useUserContext();
	const listContext = useListContext();

	const [formFields, setFormFields] = useState<IVendorDetails>({
		name: "",
		status: listContext?.vendorStatuses[0]?.value,
		lastAuditDate: moment(Date.now()).toDate(),
		method: listContext?.vendorMethods[0]?.value,
		epaId: "",
		usesExternalPriceIds: false,
		minimumLoadWeight: 0,
		zeroWeightLoadNotifications: false,
		requiresEscalatedDateChangePermission: false
	});
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const reset = async () => {
		setFormFields({
			name: "",
			status: listContext?.vendorStatuses[0]?.value,
			lastAuditDate: moment(Date.now()).toDate(),
			method: listContext?.vendorMethods[0]?.value,
			epaId: "",
			usesExternalPriceIds: false,
			minimumLoadWeight: 0,
			zeroWeightLoadNotifications: false,
			requiresEscalatedDateChangePermission: false
		});
	}

	return (
		<div className="hwi-vendor-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageVendors}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/vendor">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Vendor
						</div>
					</section>
					<section className="management-page-form">
						<VendorDetailsForm action="add" details={formFields} reloadData={reset} ></VendorDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default VendorAdd;